import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "amfe-flexible";
import "./cube-ui";
import "./components";
import "./assets/font-icon/iconfont.css";
import Navigation from "vue-navigation";
import service from "./setAxios";
import validator from "./libs/validator";
import "./components/global.less";

import { Stepper, LeftSlip, Cell, Tab, tabPanel, Dialog } from "@nutui/nutui";
Stepper.install(Vue);
LeftSlip.install(Vue);
Cell.install(Vue);
Tab.install(Vue);
tabPanel.install(Vue);
Dialog.install(Vue);

import {
  showToast,
  SuccessDialog,
  ErrorDialog,
  showDialogAlert,
  ButDialog,
  ButDialogs,
  showDialogOfferCopy
} from "./utils/index";
Vue.prototype.$mobileListUrl = "/mobile/dict/data/public/mobileList";
Vue.prototype.locationImg = "/static/images/";

Vue.use(Navigation, { router });

Vue.prototype.showToast = showToast;
Vue.prototype.SuccessDialog = SuccessDialog;
Vue.prototype.ErrorDialog = ErrorDialog;
Vue.prototype.showDialogAlert = showDialogAlert;
Vue.prototype.ButDialog = ButDialog;
Vue.prototype.ButDialogs = ButDialogs;
Vue.prototype.showDialogOfferCopy = showDialogOfferCopy;

Vue.prototype.$http = service;
Vue.prototype.validator = validator;

Vue.config.productionTip = false;

function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); //匹配目标参数
  if (r != null) return decodeURI(r[2]);
  return null; //返回参数值
}

function getCookie(name) {
  var strcookie = document.cookie; //获取cookie字符串
  var arrcookie = strcookie.split("; "); //分割
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split("=");
    if (arr[0] == name) {
      return arr[1];
    }
  }
  return "";
}

function setCookie(name, value) {
  var Days = 0.5;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie =
    name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}
Vue.prototype.getCookie = getCookie;
Vue.prototype.setCookie = setCookie;

function initPage() {
  new Vue({
    router,
    store,
    service,
    showToast,
    SuccessDialog,
    ErrorDialog,
    showDialogAlert,
    ButDialog,
    ButDialogs,
    showDialogOfferCopy,
    render: h => h(App)
  }).$mount("#app");
}

// alert(window.location.href)

var ua = navigator.userAgent.toLowerCase();
window.isWeixin = ua.indexOf("micromessenger") != -1;
window.ios = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
// 微信
window.code = getUrlParam("code");

// 判断是否初始化加载
if (!sessionStorage.refresh) {
  localStorage.clear();
  // 是否调用 code 接口
  if (window.code && window.isWeixin && localStorage.AutoLogin != 0) {
    // alert(window.code)
    service
      .get("/mobile/wechatInfo/public/acceptCode", {
        code: window.code
      })
      .then(res => {
        if (res.autoLogin == 1) {
          localStorage.setItem("AutoLogin", res.autoLogin);
          localStorage.setItem("token", res.token);
          localStorage.setItem("userId", res.userId);
          localStorage.setItem("memType", res.memType);
          localStorage.setItem("receive", res.receive);
        }
        initPage();
      });
  } else {
    initPage();
  }
} else {
  initPage();
}
sessionStorage.setItem("refresh", 0);
